export default __webpack_public_path__ + "static/media/pie_placeholder.b657d469.svg";